var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intel"},_vm._l((_vm.data),function(value,index){return _c('ViewCard',{key:index,attrs:{"data":value,"title":value.title,"tipo":"INTEL"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }